import { atom } from "jotai";

import { UpdateMemberRoundInput } from "../../../../../components/TransferOwnership/hooks/__generated__/useUpdateSingleSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../../stores";

export const updatedMemberRoundsAtom = atom<UpdateMemberRoundInput[] | null>(
  (get) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return null;
    const rounds = currentBooking.rounds;
    const memberRounds = rounds?.filter(
      (r) =>
        r.player?.clientType === "member" ||
        r.player?.clientType === "memberHold"
    );
    const input: UpdateMemberRoundInput[] = memberRounds?.map((r) => ({
      index: r.index,
      id: r.serverId,
      playerId: r.player?.id || null,
      courseLayoutId: r.type === "Golf" ? r.courseLayout?.id : null,
      transportationTypeId: r.type === "Golf" ? r.transportationType?.id : null,
      nonPlayingHost: r.isNonPlayingHost,
    }));
    return input;
  }
);
